export function getInfoSuccess(data) {
  return {
    type: '@info/GET_INFO_SUCCESS',
    payload: { data },
  };
}
